(function () {
    'use strict';

    class HomeWelcomeMessageComponent extends Controllers.BaseControllerES6 {

        // @ngInject
        constructor(
            $scope,
            $element,
            $attrs,
            $injector,
            $state,
            moment,
            UsersManager,
            CompaniesManager,
            UIUtils,
            SetupGuideService,
            DoodleService,
            Enums,
            UserService,
            AppStates,
            FeaturesService
        ) {
            super($scope, $injector);
            this.__objectType = 'HomeWelcomeMessage';

            this.user = UsersManager.getCurrUser();
            this.company = CompaniesManager.getCurrCompany();
            this.UIUtils = UIUtils;
            this.DoodleService = DoodleService;
            this.SetupGuideService = SetupGuideService;
            this.Enums = Enums;
            this.UserService = UserService;
            this.today = moment().format('ddd, MMM DD, YYYY');
            this.isAmericanUser = true;
            this.$state = $state;
            this.AppStates = AppStates;
            this.FeaturesService = FeaturesService;

            this.isNewYearPeriod = function isNewYearPeriod() {
                var beginning = moment('01/01/2020').format('ddd, MMM DD, YYYY');
                var end = moment('01/10/2020').format('ddd, MMM DD, YYYY');
                return moment(this.today).isBetween(beginning, end);
            };

            var showBirthdayDecorations = this.UserService.isTodayUsersBirthday(this.user) && this.UserService.isBankAccountTypeIndividual(this.user);

            var states = {
                morning: {
                    image: {
                        normal: "//res.cloudinary.com/honeybook/image/upload/v1524669636/system_web/home/illustration-morning.svg",
                        winter: "//res.cloudinary.com/honeybook/image/upload/v1545224282/system_web/home/Christmas_doodle_home.svg"
                    },
                    titleTranslationKey: "HOME.STATES.MORNING._TITLE_",
                    subtitleTranslationKey: "HOME.STATES.MORNING._SUBTITLE_"
                },
                afternoon: {
                    image: {
                        normal: "//res.cloudinary.com/honeybook/image/upload/v1524669636/system_web/home/illustration-afternoon.svg",
                        winter: "//res.cloudinary.com/honeybook/image/upload/v1545224282/system_web/home/Christmas_doodle_home.svg"
                    },
                    titleTranslationKey: "HOME.STATES.AFTERNOON._TITLE_",
                    subtitleTranslationKey: "HOME.STATES.AFTERNOON._SUBTITLE_"
                },
                evening: {
                    image: {
                        normal: "//res.cloudinary.com/honeybook/image/upload/v1524669636/system_web/home/illustration-evening.svg",
                        winter: "//res.cloudinary.com/honeybook/image/upload/v1545224282/system_web/home/Christmas_doodle_home.svg"
                    },
                    titleTranslationKey: "HOME.STATES.EVENING._TITLE_",
                    subtitleTranslationKey: "HOME.STATES.EVENING._SUBTITLE_"
                },
                night: {
                    image: {
                        normal: "//res.cloudinary.com/honeybook/image/upload/v1524669636/system_web/home/illustration-night.svg",
                        winter: "//res.cloudinary.com/honeybook/image/upload/v1545224282/system_web/home/Christmas_doodle_home.svg"
                    },
                    titleTranslationKey: "HOME.STATES.NIGHT._TITLE_",
                    subtitleTranslationKey: "HOME.STATES.NIGHT._SUBTITLE_"
                },
                birthday: {
                    image: {
                        normal: "//res.cloudinary.com/honeybook/image/upload/v1565041428/app/birthday.svg",
                        winter: "//res.cloudinary.com/honeybook/image/upload/v1565041428/app/birthday.svg"
                    },
                    titleTranslationKey: "HOME.STATES.HAPPY_BIRTHDAY._TITLE_",
                    subtitleTranslationKey: "HOME.STATES.HAPPY_BIRTHDAY._SUBTITLE_"
                },
                year_review: {
                    image: {
                        normal: "//res.cloudinary.com/honeybook/image/upload/v1577698246/app/home/new_year-glasses.svg",
                        winter: "//res.cloudinary.com/honeybook/image/upload/v1577698246/app/home/new_year-glasses.svg"
                    },
                    titleTranslationKey: "HOME.STATES.YEAR_REVIEW._TITLE_",
                    subtitleTranslationKey: "HOME.STATES.YEAR_REVIEW._SUBTITLE_",
                    linkText: "HOME.STATES.YEAR_REVIEW._LINK_"
                }
            };

            this.currentState = calcState();

            function calcState() {
                var currState = null;
                var currHour = parseFloat(moment().format("HH"));

                var SPLIT_MORNING   = 6;
                var SPLIT_AFTERNOON = 12;
                var SPLIT_EVENING   = 17;
                var SPLIT_NIGHT     = 22;

                if (showBirthdayDecorations) {
                    currState = states.birthday;
                } else if (
                    currHour >= SPLIT_MORNING
                    && currHour <= SPLIT_AFTERNOON
                ) {
                    currState = states.morning;
                } else if (
                    currHour >= SPLIT_AFTERNOON
                    && currHour <= SPLIT_EVENING
                ) {
                    currState = states.afternoon;
                } else if (
                    currHour >= SPLIT_EVENING
                    && currHour <= SPLIT_NIGHT
                ) {
                    currState = states.evening;
                } else {
                    currState = states.night;
                }

                return currState;
            }

            this.yearInReviewRedirect = function yearInReviewRedirect() {
                this.$state.go(this.AppStates.root_core_navigation_yearInReview);
            };


            // we removed this as we didnt want to do this
            /*
            var _setIsAmericanUser = function _setIsAmericanUser() {
                this.isAmericanUser = this.company && this.company.country && this.company.country.toLowerCase() === "us";
            }.bind(this);


            if (this.company.wasFullyFetched()) {
                _setIsAmericanUser();
            } else {
                this.registerOnce(this.company, 'success', _setIsAmericanUser);
            }*/

            this.getImage = function getImage() {
                var image = {
                    url : this.currentState.image.normal
                };

                var currDoodle = DoodleService.getDoodle();

                switch(currDoodle){
                    case Enums.doodles.winter:
                        image.url = this.currentState.image.winter;
                        break;
                    default:
                        image.url = this.currentState.image.normal;
                }

                if (currDoodle === Enums.doodles.thanksgiving && this.isAmericanUser) {
                    image.url = "//res.cloudinary.com/honeybook/image/upload/v1574775307/Thanksgiving_1_xbts2e.svg";
                    image.title = "Happy Thanksgiving!";
                }

                return image;
            };

            this.image = this.getImage();
        }
    }

    Components.HomeWelcomeMessage = {
        controller: HomeWelcomeMessageComponent,
        templateUrl: 'angular/app/modules/core/features/home/welcome_message/welcome_message_component_template.html',
    };

}());
